var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CustomSelect',_vm._b({attrs:{"itemComponent":_vm.component,"search":""},on:{"input":function($event){return _vm.$emit('input', $event)}}},'CustomSelect',_vm.$props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }